var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-box acea-row row-between" }, [
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.titleTxt))]),
    _c(
      "div",
      { staticClass: "textVal acea-row row-middle row-right" },
      _vm._l(_vm.list, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "item acea-row row-middle" },
          [
            _c(
              "div",
              {
                staticClass: "select acea-row row-center-wrapper",
                class: item.show ? "on" : "",
              },
              [
                item.show
                  ? _c("span", { staticClass: "iconfont icon-complete" })
                  : _vm._e(),
              ]
            ),
            _c("div", [_vm._v(_vm._s(item.val))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }